function formatIssueClass(issue) {
  return issue
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '')
    .replace(/-/g, '');
}

function formatCommittees(committee){
  return committee
    .split(/\r?\n/)
    .map(c => c.trim())
    .filter(Boolean)
    .join(', ');
}

export function Cards({ data }) {

  const cards = data?.hits || [];

  if (!cards.length) {
    return (
        <p>No data available</p>
    );
  }

  return (
    <>
      {cards.map((bill) => {

        const cardUrl = `./${bill.id}`;
        const cardTitle = `${bill.billDisplayNumber} - ${bill.billTitle}`;
        const cardSponsor = bill.billSponsor;
        const cardSession = bill.billCongressNumber;
        const cardCommittee = formatCommittees(bill.billCommittees);
        const cardDate = bill.billIntroducedDated;

        return (
          <a
            key={bill.id}
            href={cardUrl}
            className="bill-card"
          >

            <h2 className="bill-title">
              {cardTitle}
            </h2>

            <hr />

            <p className="bill-sponsor">
              <strong>Sponsor:</strong> {cardSponsor}
            </p>

            <p className="bill-session">
              <strong>Session:</strong> {cardSession}
            </p>

            <p className="bill-committee">
              <strong>Committee(s):</strong> {cardCommittee}
            </p>

            <p className="bill-date">
              <strong>Bill Introduced:</strong> {cardDate}
            </p>

            <hr className="bottomHr"></hr>
            {bill.billEvidenceProvisions && (
              <div className="evidenceProvisionList">
                <p>Evidence Provision(s):</p>
                {bill.billEvidenceProvisions.map((issue, index) => (
                  <span
                    key={index}
                    className={`${formatIssueClass(issue)} billEvidenceProvision`}
                  >
                    {issue}
                  </span>
                ))}
              </div>
            )}
            {bill.billIssueArea && (
              <div className="issueAreaList">
                <p>Issue Area(s):</p>
                {bill.billIssueArea.map((issue, index) => (
                  <span
                    key={index}
                    className={`${formatIssueClass(issue)} billIssueArea`}
                  >
                    {issue}
                  </span>
                ))}
              </div>
            )}

          </a>
        );
      })}
    </>
  );
}
